import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { config } from '../config';

const api = axios.create({
	baseURL: `${config.backUrl}/api`,
});

const sendData = <T>(res: AxiosResponse<T>): T => res.data;

async function get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
	return api
		.get<T>(url, config)
		.catch(err => {
			throw err;
		})
		.then(res => sendData<T>(res));
}

async function del<T>(url: string): Promise<T> {
	return api
		.delete<T>(url)
		.catch(err => {
			throw err;
		})
		.then(res => sendData<T>(res));
}

async function download(url: string, method: string, data?: unknown): Promise<Blob> {
	return api({ url: url, data: data, method: method, responseType: 'blob' })
		.catch(err => {
			throw err;
		})
		.then(res => res.data);
}

async function post<T, D = unknown>(url: string, data?: D): Promise<T> {
	return api
		.post<T>(url, data)
		.catch(err => {
			throw err;
		})
		.then(res => sendData<T>(res));
}

async function put<T, D = unknown>(url: string, data?: D): Promise<T> {
	return api
		.put<T>(url, data)
		.catch(err => {
			throw err;
		})
		.then(res => sendData<T>(res));
}

function authorization(token?: string | null): void {
	if (token) api.defaults.headers.common.Authorization = `Bearer ${token}`;
	else delete api.defaults.headers.common.Authorization;
}

export const client = { get, del, post, put, download, authorization };
